import { SVGProps } from 'react';

import * as St from './ActionButton.styles';

import { invertColor } from '~/redux/slices/color/color.utils';

interface ActionButtonProps {
  title: string;
  color: string;
  Icon: (props: SVGProps<SVGSVGElement>) => JSX.Element;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const ActionButton = ({
  title,
  color,
  onClick,
  Icon,
}: ActionButtonProps): JSX.Element => {
  const bgColor = invertColor(color, false);
  const filter = [
    `drop-shadow(1px 1px 0px ${bgColor})`,
    `drop-shadow(0px 0px 1px ${bgColor})`,
    `drop-shadow(0px 0px 1px ${bgColor})`,
  ].join(' ');

  return (
    <St.Container onClick={onClick}>
      <St.IconText style={{ color, filter }}>{title}</St.IconText>
      <Icon
        className="icon-image"
        style={{ fontSize: '24rem', color, filter }}
      />
    </St.Container>
  );
};

export default ActionButton;
